export const CART_COUNTDOWN = 3
